function view (path) {
  return () => import(/* webpackChunkName: 'rm-v1' */ '@/views/rm/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

function viewPurchaseOrders (path) {
  return view('purchase-orders/' + path)
}

const RRetailManager = [
  {
    path: '/retail-manager/dashboard',
    component: view('Dashboard'),
    name: 'rm.dashboard',
    authorizedRole: 'rm'
  }
]

const RPOPurchaseOrders = [
  {
    path: '/retail-manager/purchase-orders/approvals/:approver?/:status?',
    component: viewPurchaseOrders('approvals/Base'),
    name: 'rm.purchase-orders.approvals',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  },
  {
    path: '/retail-manager/purchase-orders/requests/:requester?/:status?',
    component: viewPurchaseOrders('requests/Base'),
    name: 'rm.purchase-orders.requests',
    meta: {
      breadcrumb: [
        {
          text: 'Retail Manager'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Requests',
          active: true
        }
      ]
    }
  },
  {
    path: '/retail-manager/purchase-orders/receiving/:receiver?/:status?',
    component: viewPurchaseOrders('receiving/Base'),
    name: 'rm.purchase-orders.receiving',
    meta: {
      breadcrumb: [
        {
          text: 'Retail Manager'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

const RPOInterBranches = [
  {
    path: '/retail-manager/inter-branches/approvals/:approver?/:status?',
    component: view('approvals/inter-branches/Base'),
    name: 'rm.inter-branches.approvals',
    authorizedRole: 'rm',
    meta: {
      breadcrumb: [
        {
          text: 'Retail Manager'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  }
]

export default RRetailManager.concat(
  RPOPurchaseOrders,
  RPOInterBranches
)
